import { TypedDocumentNode, gql } from "@apollo/client";

interface OfferData {
  offerByCategory: Offer | null;
}

export enum CategoryType {
  ALL_COUNTRY_ADVANCE_DISCOUNT = "ALL_COUNTRY_ADVANCE_DISCOUNT",
  PARTICIPANT_DISCOUNT = "PARTICIPANT_DISCOUNT",
  EARLY_BIRD_OFFER_ONLY_DISCOUNT = "EARLY_BIRD_OFFER_ONLY_DISCOUNT",
  ALL_COUNTRIES_ONLY_COUPON = "ALL_COUNTRIES_ONLY_COUPON",
  INDIVIDUAL_COUNTRY_ONLY_COUPON = "INDIVIDUAL_COUNTRY_ONLY_COUPON",
}

interface OfferVars {
  type: CategoryType;
}

export const GET_OFFER: TypedDocumentNode<OfferData, OfferVars> = gql`
  query GetOffer($type: CategoryType!) {
    offerByCategory(categoryType: $type) {
      name
      couponCode
      startDate
      endDate
      banner
      description
    }
  }
`;
